import React, { FC } from 'react';
import { NotificationBanner } from 'src/components/widgets/notificationBanner';
import { Link } from 'src/components/widgets/buttons';
import { T } from 'src/shared/helpers';

// Matches getGenerativeAiServiceConfig().learnMoreUrl (serviceCreditsConfigs.tsx).
const AI_CREATIVE_TOOLS_GUIDE_URL = 'https://zakeke.zendesk.com/hc/en-us/sections/23868451889180-AI-Creative-Tools';

interface DiscoveryAiActivationBannerProps {
    /** Grants the one-time free trial pack (auto-refill off); the parent re-resolves + opens any pending tool. */
    onActivate: () => void;
    /** True while the grant mutation is in flight — disables the button to prevent a double activation. */
    isActivating: boolean;
}

/**
 * Discovery-mode "This tool is billed via credits" banner (CASE 1: the seller has never activated the free
 * trial nor bought credits). Shown persistently at the top of the AI Creative Tools panel while the seller is
 * un-activated — the same copy as the original AI-rule setup pages, rendered inline (not a modal). The AI-tool
 * gate still holds: engaging a tool won't open it until the seller activates from here.
 */
const DiscoveryAiActivationBanner: FC<DiscoveryAiActivationBannerProps> = ({ onActivate, isActivating }) => (
    <NotificationBanner
        type='AI'
        variant='extended'
        content={
            <>
                <strong>{T._('This tool is billed via credits', 'Admin')}</strong>
                {'\n'}
                {T._(
                    'When you activate this tool, a set of free credits is added to your account. Once the free credits are used up, you will be notified by email and in your Zakeke admin — you can then purchase a credit pack anytime to keep using the AI Creative Tools.',
                    'Admin'
                )}{' '}
                <Link href={AI_CREATIVE_TOOLS_GUIDE_URL} target='_blank'>
                    {T._('Learn more', 'Admin')}
                </Link>
            </>
        }
        buttons={[
            {
                label: isActivating ? T._('Activating…', 'Admin') : T._('Activate free credits', 'Admin'),
                onClick: onActivate,
                disabled: isActivating
            }
        ]}
    />
);

export default DiscoveryAiActivationBanner;
